import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_DE_UQ || "uq.de.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_DE_UQ || 24166,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_DE_UQ || 24168,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_DE_UQ ||
    "1:160978693362:web:69912a36226563c047346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-83CRD0G2RC" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.DE, LANGUAGE.EN]
};

export default _countryEnv;
